module.exports = __webpack_public_path__ + "img/ic_like_normal.910f88d5.svg";